var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "14px",
    viewBox: "0 0 20 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visible",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#333333",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,12 C12.3137085,12 15.3137085,10 18,6 C15.3137085,2 12.3137085,0 9,0 C5.6862915,0 2.6862915,2 0,6 C2.6862915,10 5.6862915,12 9,12 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 6,
    r: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/Visible.ae193de792b51a76e3b20e468012b98f.svg";
export { ForwardRef as ReactComponent };